module.exports = __webpack_public_path__ + "img/SD-WANcase.c55cb0fb.png";